import Repository from "../Repository";

const resource = "/product/lift";

export default {
  /**
   * Get a lift product
   * @param {String} lift_uuid Lift uuid
   */
  async get(lift_uuid) {
    return Repository.get(`${resource}/${lift_uuid}`);
  },

  async createLift(payload) {
    return Repository.post(`${resource}`, payload);
  }
};
